import { Image } from '../ui.interfaces';

export interface DynamicBannerContent {
  imageContent?: ImagePaths;
  bannerIndex?: string;
  description?: string;
  headerText?: string;
  badgeText?: string;
  mobilePlacementID?: string;
  moreText?: string;
  level?: string;
}

export interface ImagePaths {
  desktop?: Image;
  mobile?: Image;
  tablet?: Image;
}
